import React from 'react';

import { TermActionMobile } from '../shared/TermAction/mobile';
import { TermActionViewProps } from '../shared/TermAction/types';

export const TermAcceptanceMobile: React.FC<TermActionViewProps> = (props) => {
  return <TermActionMobile {...props} />;
};
